import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../pages/Login';
import Home from '../pages/Home';
import NotFound from '../pages/NotFound';
import DashboardPage from '../pages/DashboardPage';
import CategoryGroupsPage from '../pages/CategoryGroupsPage';
import IncidentsPage from '../pages/IncidentsPage';
import PlacesPage from '../pages/PlacesPage';
import NotificationsPage from '../pages/NotificationsPage';
import NewsPage from '../pages/NewsPage';
import MayorPage from '../pages/MayorPage';
import IssuesPage from '../pages/IssuesPage';
import SettingsPage from '../pages/SettingsPage';
//import NotFoundBg from "../../public/404error.jpg";

import authStore from '@/store/modules/auth';
Vue.use(VueRouter)

const routes = [
    {
        // Login Page
        path: '/samsun/login',
        name: 'login',
        component: Login,
        meta: {
            realm : 'samsun'
        }
    },
    {
        // Login Page
        path: '/tekirdag/login',
        name: 'login',
        component: Login,
        meta: {
            realm : 'tekirdag'
        }
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: Home,
        children: [
            { path: '', component: DashboardPage }
        ],
        meta: {
            requiresAuth: true,
            reload: true
        }
    },
    {
        path: '/category-groups',
        name: 'category-groups',
        component: Home,
        children: [
            { path: '', name: 'categorygroups', component: CategoryGroupsPage }
        ],
        meta: {
            requiresAuth: true,
            reload: true
        }
    },
    {
        path: '/mayor',
        name: 'mayor',
        component: Home,
        children: [
            { path: '', name: 'mayor', component: MayorPage }
        ],
        meta: {
            requiresAuth: true,
            reload: true
        }
    },
    {
        path: '/places',
        name: 'places',
        component: Home,
        children: [
            { path: ':place/:id', name: 'placespage', component: PlacesPage }
        ],
        meta: {
            requiresAuth: true,
            reload: true
        }
    },
    {
        path: '/incidents',
        name: 'incidents',
        component: Home,
        children: [
            { path: '', name: 'incidents', component: IncidentsPage }
        ],
        meta: {
            requiresAuth: true,
            reload: true
        }
    },
    {
        path: '/notifications',
        name: 'notifications',
        component: Home,
        children: [
            { path: '', name: 'notifications', component: NotificationsPage }
        ],
        meta: {
            requiresAuth: true,
            reload: true
        }
    },
    {
        path: '/issues',
        name: 'issues',
        component: Home,
        children: [
            { path: '', name: 'issues', component: IssuesPage }
        ],
        meta: {
            requiresAuth: true,
            reload: true
        }
    },
    {
        path: '/news',
        name: 'news',
        component: Home,
        children: [
            { path: '', name: 'news', component: NewsPage }
        ],
        meta: {
            requiresAuth: true,
            reload: true
        }
    },
    {
        path: '/settings',
        name: 'settings',
        component: Home,
        children: [
            { path: '', name: 'settings', component: SettingsPage }
        ],
        meta: {
            requiresAuth: true,
            reload: true
        }
    },
    {
        path: '*',
        name: 'NotFound',
        component: NotFound,
        //meta: { bgImage: NotFoundBg }

    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        let jwt = authStore.getters.jwtDecoded(authStore.state);
        if (authStore.state.token && jwt.exp * 1000 > Date.now()) {
            console.log('There is a token and not expired, resume. (' + to.path + ')');
            next();
        } else {
            console.log('There is no token or expired, redirect to login. (' + to.path + ')');
            next('/' + authStore.state.realm + '/login');
        }
    } else {
        console.log('You\'re on the login page');
        next();
    }
});

// router.afterEach(to => {
//     if (to.meta && to.meta.bgImage) {
//       document.body.style.backgroundRepeat = "no-repeat";
//       document.body.style.backgroundPosition = "center";
//       document.body.style.backgroundSize = "cover";
//       document.body.style.backgroundImage = `url(${to.meta.bgImage})`;
//     } else {
//       document.body.style.backgroundRepeat = "";
//       document.body.style.backgroundPosition = "";
//       document.body.style.backgroundImage = "";
//     }
//   });


export default router